import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { MenuGuard } from '@core';
import { DefaultPageComponent } from '@core/default-page/default-page.component';
import { AppLayoutComponent } from '../theme/app-layout/app-layout.component';
import { routePath } from './routes-path.config';

const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      { path: '', component: DefaultPageComponent, pathMatch: 'full' },
      {
        path: routePath.DASHBOARD,
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
        canLoad: [MenuGuard],
      },
      {
        path: routePath.TICKET,
        loadChildren: () => import('./ticket/ticket.module').then(m => m.TicketModule),
        canLoad: [MenuGuard],
      },
      {
        path: routePath.SOP,
        loadChildren: () => import('./sop/sop.module').then(m => m.SOPModule),
      },
      {
        path: routePath.PROPERTY_MANAGEMENT,
        loadChildren: () =>
          import('./propertymanagement/propertymanagement.module').then(
            m => m.PropertyManagementModule
          ),
        canLoad: [MenuGuard],
        canActivate: [MsalGuard],
      },
      {
        path: routePath.SELF_SERVICE,
        loadChildren: () =>
          import('./selfservice/selfservice.module').then(m => m.SelfServiceModule),
        canLoad: [MenuGuard],
        canActivate: [MsalGuard],
      },
      {
        path: routePath.PROFILE,
        loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule),
        // canLoad: [MenuGuard],
        // canActivate: [MsalGuard],
      },
      {
        path: routePath.AUTHENTICATION,
        loadChildren: () =>
          import('./authentication/authentication.module').then(m => m.AuthenticationModule),
      },
      {
        path: routePath.TASKS,
        loadChildren: () => import('./tasks/tasks.module').then(m => m.TasksModule),
        canActivate: [MsalGuard],
      },
      {
        path: routePath.INFO,
        loadChildren: () => import('./info/info.module').then(m => m.InfoModule),
      },
      {
        path: routePath.ADMIN,
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
      },
      {
        path: routePath.PERMISSION_REQUEST,
        loadChildren: () =>
          import('./permission-request/permission-request.module').then(
            m => m.PermissionRequestModule
          ),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
      initialNavigation: 'enabledBlocking',
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class RoutesRoutingModule {}
